module.exports = __webpack_public_path__ + "static/img/08.bd3378a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/08.jpg
// module id = hE4s
// module chunks = 0